/**
 * 桂运宝官网可核验事实与各页 SEO 配置。
 * 文案只使用 2026 公司简介和官网已公布的联系方式。
 */

export const SITE = {
  name: "广西桂运宝科技有限公司",
  brand: "桂运宝",
  siteName: "桂运宝货运平台",
  origin: "https://guiyunbao.cn",
  phone: "0772-2991568",
  phoneHref: "tel:07722991568",
  shipperPhone: "18178808555",
  shipperPhoneHref: "tel:18178808555",
  email: "260635427@qq.com",
  streetAddress: "广场路10号柳州地王国际财富中心2栋38-9",
  address: "柳州市广场路10号柳州地王国际财富中心2栋38-9",
  region: "广西壮族自治区",
  locality: "柳州市",
  ogImage: "https://guiyunbao.cn/og-cover.jpg",
  keywords:
    "桂运宝,专线,大宗物流,货物运输,回头车,顺路车,电车,车队,运力,新能源,新能源车队,回程车,转线运输,口碑最好物流,网络货运,物流APP,货运平台,物流平台,调度系统,物流培训系统,物流培训,物流证,物流考试,柳州大宗货运,大宗整车运输,新能源重卡",
  entitySummary:
    "广西桂运宝科技有限公司，总部柳州，广西本土大宗货物网络货运综合服务商。2010年起深耕公路货运，2021年注册并上线自研平台，首批通过广西交通运输厅网络货运线上服务能力认定。服务工矿、建材、农林、钢铁、水泥、电厂、有色，业务立足广西，辐射华南、华东、西南。",
  areas: ["广西", "华南", "华东", "西南"],
};

/**
 * 统计汉字数量，用来核对标题和描述是否落在目标区间。
 * @param {string} text
 * @returns {number}
 */
export function countHan(text) {
  const matched = String(text || "").match(/[\u4e00-\u9fff]/g);
  return matched ? matched.length : 0;
}

/**
 * @param {string} path
 * @returns {string}
 */
export function absoluteUrl(path) {
  if (!path || path === "/") {
    return SITE.origin + "/";
  }
  return SITE.origin + path;
}

const homeDescription =
  "广西桂运宝科技有限公司总部在柳州，是广西本土大宗货物网络货运综合服务商。2021年上线自研平台，并通过广西交通运输厅网络货运线上服务能力认定。服务工矿、建材、钢铁、水泥等整车运输，咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const aboutDescription =
  "了解广西桂运宝科技有限公司：总部位于柳州，从事大宗货物网络货运，使用AI调度，并运营新能源重卡。合规上落实运单、资金、票据、证件、定位五流合一。2021年通过广西交通运输厅网络货运线上服务能力认定。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const solutionsDescription =
  "桂运宝大宗货运业务方案覆盖工矿、建材、农林、钢铁、水泥、电厂、有色和新能源重卡。广西桂运宝科技有限公司总部在柳州，业务辐射华南、华东、西南，提供大宗整车运输。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const bulkDescription =
  "桂运宝为广西工矿、建材、农林客户提供大宗整车运输，立足柳州，辐射华南、华东、西南。调度包含货源聚合、运力匹配和AI语音播报，并落实五流合一。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const steelDescription =
  "桂运宝承运钢铁、水泥、电厂、有色等大宗整车货物，总部在广西柳州。运力包括自有新能源重卡，以及顺路车、回头车、返程车和运输车队。运输过程落实五流合一。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const energyDescription =
  "桂运宝已投入自有新能源重卡商业化运营，车辆零排放，并整合顺路车、回头车、返程车和运输车队。公司总部在广西柳州，服务大宗整车运输。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const faqDescription =
  "解答桂运宝是做什么的、公司在哪里、是否具备网络货运资质、服务哪些区域、承运哪些货类、什么是五流合一、有没有新能源重卡。广西桂运宝科技有限公司总部在柳州，电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const newsDescription =
  "2021年1月8日，广西交通运输厅综合运输管理处领导莅临柳州桂运宝，检查网络货运平台线上服务能力。本文由广西桂运宝科技有限公司发布，介绍检查过程与平台服务。电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const companyNewsDescription =
  "查看广西桂运宝科技有限公司新闻与业务进展。公司总部在柳州，从事大宗货物网络货运，服务工矿、建材、钢铁、水泥等客户。新闻列表暂时无法更新时，请先阅读公司简介。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const truckageDescription =
  "在桂运宝货运平台查询专线与运费参考。广西桂运宝科技有限公司总部在柳州，提供大宗整车网络货运，业务辐射华南、华东、西南。咨询电话0772-2991568，业务合作18178808555。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

const notFoundDescription =
  "您访问的页面不存在。请返回桂运宝首页、大宗货运业务方案或常见问题。广西桂运宝科技有限公司总部在柳州，提供网络货运服务。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。";

export const CAPACITY_ROWS = [
  {
    type: "自有新能源重卡",
    role: "零排放，已投入商业化运营，用于绿色低碳的大宗整车运输。",
  },
  {
    type: "社会运力",
    role: "包括顺路车、回头车、返程车和运输车队，承接多场景大宗货运。",
  },
];

export const FAQ_ITEMS = [
  {
    question: "桂运宝是做什么的？",
    answer:
      "广西桂运宝科技有限公司是总部在柳州的大宗货物网络货运综合服务商。公司为工矿、建材、农林、钢铁、水泥、电厂、有色等客户提供大宗整车运输，并把线上调度系统与线下运力网络放在一起运营。",
  },
  {
    question: "广西桂运宝科技有限公司在哪里？",
    answer:
      "公司总部在广西柳州市广场路10号柳州地王国际财富中心2栋38-9。客服电话是0772-2991568，业务合作电话是18178808555，邮箱是260635427@qq.com。",
  },
  {
    question: "桂运宝是否具备网络货运资质？",
    answer:
      "2021年桂运宝科技注册并上线自研货运平台，首批通过广西交通运输厅网络货运线上服务能力认定，并接入省级监管平台。公司按承运平台要求落实运单、资金、票据、证件、定位五流合一。",
  },
  {
    question: "桂运宝服务哪些区域？",
    answer:
      "业务立足广西，辐射华南、华东、西南。2024年起公司按总部强中台、属地轻前端推进广西全域布局，并设立属地分公司。",
  },
  {
    question: "桂运宝承运哪些大宗货物？",
    answer:
      "主要服务工矿、建材、农林、钢铁、水泥、电厂、有色等实体产业的大宗整车运输。页面不承诺某一条未公布的固定专线。",
  },
  {
    question: "什么是五流合一？",
    answer:
      "五流合一指运单、资金、票据、证件、定位在运输过程中保持一致。桂运宝用全程可视化落实这五项，用于货物运输安全和财税合规。",
  },
  {
    question: "桂运宝有自有新能源重卡吗？",
    answer:
      "有。公司已投入首批自有新能源重卡进行商业化运营，车辆零排放。与此同时，社会运力仍包括顺路车、回头车、返程车和运输车队。",
  },
  {
    question: "桂运宝如何调度车辆？",
    answer:
      "自研平台以AI大模型和行业数据做货源聚合、运力画像匹配和AI语音播报，调度流程覆盖到订单确认。系统还包括货运APP、车辆调度、业务培训和智能体执行平台。",
  },
  {
    question: "货主如何联系桂运宝？",
    answer:
      "业务合作请拨打18178808555，客服热线是0772-2991568，也可以发送邮件到260635427@qq.com，或关注桂运宝微信公众号。",
  },
  {
    question: "桂运宝的运力从哪里来？",
    answer:
      "运力分两层：一层是自有新能源重卡，一层是标准化的社会运力和合作车队。公司用培训系统统一员工、加盟商和合作司机的作业规范。",
  },
];

const solutionLinks = [
  {
    to: "/solutions/bulk-freight",
    text: "工矿建材与农林大宗整车运输",
  },
  {
    to: "/solutions/steel-cement",
    text: "钢铁、水泥、电厂、有色运输",
  },
  {
    to: "/solutions/new-energy-truck",
    text: "新能源重卡与社会运力",
  },
];

/**
 * @param {Array<{name: string, path: string}>} crumbs
 * @returns {Array<{name: string, path: string}>}
 */
function withHome(crumbs) {
  return [{ name: "首页", path: "/" }].concat(crumbs);
}

export const PAGES = {
  home: {
    path: "/",
    title: "广西桂运宝科技有限公司官网-柳州大宗货物网络货运平台",
    description: homeDescription,
    h1: "桂运宝：广西大宗货物网络货运",
    crumbs: [{ name: "首页", path: "/" }],
    includeWebSite: true,
  },
  about: {
    path: "/about",
    title: "广西桂运宝科技有限公司简介-柳州大宗网络货运服务平台",
    description: aboutDescription,
    h1: "关于广西桂运宝科技有限公司",
    crumbs: withHome([{ name: "关于我们", path: "/about" }]),
  },
  solutions: {
    path: "/solutions",
    title: "桂运宝大宗货运业务方案-覆盖广西工矿建材与钢铁水泥运输",
    description: solutionsDescription,
    h1: "桂运宝大宗货物运输业务方案",
    crumbs: withHome([{ name: "业务方案", path: "/solutions" }]),
    links: solutionLinks,
    paragraphs: [
      "广西桂运宝科技有限公司把货源聚合、车货匹配、调度播报和订单确认放在同一套系统里，为实体产业客户组织大宗整车运输。",
      "服务行业包括工矿、建材、农林、钢铁、水泥、电厂、有色。业务立足广西柳州，辐射华南、华东、西南。",
    ],
  },
  bulk: {
    path: "/solutions/bulk-freight",
    title: "桂运宝网络货运平台提供广西工矿建材大宗整车运输服务",
    description: bulkDescription,
    h1: "广西工矿建材与农林大宗整车运输",
    crumbs: withHome([
      { name: "业务方案", path: "/solutions" },
      { name: "工矿建材与农林", path: "/solutions/bulk-freight" },
    ]),
    serviceName: "工矿建材与农林大宗整车运输",
    paragraphs: [
      "这一方案面向工矿、建材、农林客户的大宗整车需求。桂运宝按票组织运输，而不是把零担小票和大宗整车混在同一套说明里。",
      "调度先聚合货源，再按运力画像匹配车辆，并用AI语音播报调度信息，直到订单确认。",
      "合规上落实运单、资金、票据、证件、定位五流合一。2021年平台通过广西交通运输厅网络货运线上服务能力认定。",
    ],
    links: solutionLinks.filter(function (item) {
      return item.to !== "/solutions/bulk-freight";
    }),
  },
  steel: {
    path: "/solutions/steel-cement",
    title: "柳州桂运宝货运平台承运钢铁水泥电厂有色大宗运输服务",
    description: steelDescription,
    h1: "钢铁、水泥、电厂、有色大宗运输",
    crumbs: withHome([
      { name: "业务方案", path: "/solutions" },
      { name: "钢铁水泥电厂有色", path: "/solutions/steel-cement" },
    ]),
    serviceName: "钢铁、水泥、电厂、有色大宗运输",
    showCapacity: true,
    paragraphs: [
      "钢铁、水泥、电厂、有色货物以大宗整车为主。桂运宝用自有新能源重卡和社会运力共同承接，具体运力按货源和线路组织，不在本页承诺未公布的固定专线。",
      "运输过程保持可视化，运单、资金、票据、证件、定位五项一致，降低货主在票据和轨迹上的合规风险。",
    ],
    links: solutionLinks.filter(function (item) {
      return item.to !== "/solutions/steel-cement";
    }),
  },
  energy: {
    path: "/solutions/new-energy-truck",
    title: "桂运宝自有新能源重卡运输并整合社会运力承运大宗货物",
    description: energyDescription,
    h1: "新能源重卡与社会运力",
    crumbs: withHome([
      { name: "业务方案", path: "/solutions" },
      { name: "新能源重卡与社会运力", path: "/solutions/new-energy-truck" },
    ]),
    serviceName: "新能源重卡与社会运力",
    showCapacity: true,
    paragraphs: [
      "自有运力是已投入商业化运营的新能源重卡，车辆零排放，用于绿色低碳的大宗运输。",
      "社会运力包括顺路车、回头车、返程车和运输车队，用来覆盖自有车辆之外的大宗整车需求。",
      "两类运力使用同一套调度和合规要求，不把新能源车辆和社会车辆分成两套服务标准。",
    ],
    links: solutionLinks.filter(function (item) {
      return item.to !== "/solutions/new-energy-truck";
    }),
  },
  faq: {
    path: "/faq",
    title: "桂运宝货运平台常见问题-广西网络货运资质服务范围说明",
    description: faqDescription,
    h1: "桂运宝常见问题",
    crumbs: withHome([{ name: "常见问题", path: "/faq" }]),
    faq: FAQ_ITEMS,
  },
  news: {
    path: "/news",
    title: "自治区交通厅莅临柳州桂运宝检查网络货运平台工作纪实",
    description: newsDescription,
    h1: "自治区交通厅领导莅临桂运宝检查平台工作",
    crumbs: withHome([{ name: "平台检查纪实", path: "/news" }]),
    article: {
      headline: "自治区交通厅领导莅临桂运宝检查平台工作",
      datePublished: "2021-01-08",
      author: "广西桂运宝科技有限公司",
    },
  },
  companynews: {
    path: "/companynews",
    title: "广西桂运宝公司新闻-柳州大宗货物网络货运平台最新动态",
    description: companyNewsDescription,
    h1: "桂运宝公司新闻",
    crumbs: withHome([{ name: "公司新闻", path: "/companynews" }]),
  },
  truckage: {
    path: "/truckage",
    title: "桂运宝柳州货运平台的专线运费查询与大宗货物运输说明",
    description: truckageDescription,
    h1: "专线及运费查询",
    crumbs: withHome([{ name: "运费查询", path: "/truckage" }]),
  },
  notFound: {
    path: "/404",
    title: "页面未找到-请返回桂运宝广西大宗货物网络货运平台首页",
    description: notFoundDescription,
    h1: "页面未找到",
    crumbs: withHome([{ name: "页面未找到", path: "/404" }]),
  },
  newsdetail: {
    path: "/newsdetail",
    title: "桂运宝公司新闻详情-柳州大宗货物网络货运平台最新动态",
    description:
      "查看广西桂运宝科技有限公司新闻详情。公司总部在柳州，从事大宗货物网络货运，服务工矿、建材、钢铁、水泥等客户，业务辐射华南、华东、西南。咨询电话0772-2991568。公司扎根广西大宗货运行业十余年，持续服务实体产业客户。",
    h1: "新闻详情",
    crumbs: withHome([
      { name: "公司新闻", path: "/companynews" },
      { name: "新闻详情", path: "/newsdetail" },
    ]),
  },
};

/**
 * @param {string} name
 * @param {string} key
 * @param {string} value
 */
function setMeta(name, key, value) {
  let tag = document.querySelector("meta[" + name + '="' + key + '"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(name, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
}

/**
 * @returns {Object}
 */
function organizationNode() {
  return {
    "@type": "Organization",
    "@id": absoluteUrl("/") + "#organization",
    name: SITE.name,
    alternateName: SITE.brand,
    url: absoluteUrl("/"),
    logo: absoluteUrl("/favicon.ico"),
    image: SITE.ogImage,
    email: SITE.email,
    telephone: "+86-0772-2991568",
    description: SITE.entitySummary,
    address: {
      "@type": "PostalAddress",
      addressCountry: "CN",
      addressRegion: SITE.region,
      addressLocality: SITE.locality,
      streetAddress: SITE.streetAddress,
    },
    areaServed: SITE.areas,
  };
}

/**
 * @returns {Object}
 */
function localBusinessNode() {
  return {
    "@type": "LocalBusiness",
    "@id": absoluteUrl("/") + "#localbusiness",
    name: SITE.name,
    url: absoluteUrl("/"),
    image: SITE.ogImage,
    telephone: "+86-0772-2991568",
    email: SITE.email,
    address: {
      "@type": "PostalAddress",
      addressCountry: "CN",
      addressRegion: SITE.region,
      addressLocality: SITE.locality,
      streetAddress: SITE.streetAddress,
    },
    areaServed: SITE.areas,
    parentOrganization: { "@id": absoluteUrl("/") + "#organization" },
  };
}

/**
 * @param {Array<{name: string, path: string}>} crumbs
 * @returns {Object}
 */
function breadcrumbNode(crumbs) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map(function (item, index) {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        item: absoluteUrl(item.path),
      };
    }),
  };
}

/**
 * @param {Object} page
 * @returns {Array<Object>}
 */
function graphNodes(page) {
  const nodes = [organizationNode(), localBusinessNode()];
  if (page.includeWebSite) {
    nodes.push({
      "@type": "WebSite",
      "@id": absoluteUrl("/") + "#website",
      name: SITE.siteName,
      url: absoluteUrl("/"),
      publisher: { "@id": absoluteUrl("/") + "#organization" },
      inLanguage: "zh-CN",
    });
  }
  if (page.crumbs && page.crumbs.length) {
    nodes.push(breadcrumbNode(page.crumbs));
  }
  if (page.serviceName) {
    nodes.push({
      "@type": "Service",
      name: page.serviceName,
      serviceType: "大宗货物网络货运",
      provider: { "@id": absoluteUrl("/") + "#organization" },
      areaServed: SITE.areas,
      url: absoluteUrl(page.path),
      description: page.description,
    });
  }
  if (page.faq && page.faq.length) {
    nodes.push({
      "@type": "FAQPage",
      mainEntity: page.faq.map(function (item) {
        return {
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        };
      }),
    });
  }
  if (page.article) {
    nodes.push({
      "@type": "Article",
      headline: page.article.headline,
      datePublished: page.article.datePublished,
      author: {
        "@type": "Organization",
        name: page.article.author,
      },
      publisher: { "@id": absoluteUrl("/") + "#organization" },
      mainEntityOfPage: absoluteUrl(page.path),
      image: SITE.ogImage,
      description: page.description,
    });
  }
  return nodes;
}

/**
 * 把标题、描述、分享信息和结构化数据写入 head，供预渲染保存。
 * @param {Object} page
 */
export function applyHead(page) {
  const url = absoluteUrl(page.path);
  document.title = page.title;
  setMeta("name", "description", page.description);
  setMeta("name", "keywords", page.keywords || SITE.keywords);
  setMeta("property", "og:title", page.title);
  setMeta("property", "og:description", page.description);
  setMeta("property", "og:url", url);
  setMeta("property", "og:type", page.article ? "article" : "website");
  setMeta("property", "og:image", SITE.ogImage);
  setMeta("property", "og:locale", "zh_CN");
  setMeta("property", "og:site_name", SITE.siteName);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", page.title);
  setMeta("name", "twitter:description", page.description);
  setMeta("name", "twitter:image", SITE.ogImage);

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);

  let script = document.getElementById("seo-jsonld");
  if (!script) {
    script = document.createElement("script");
    script.id = "seo-jsonld";
    script.setAttribute("type", "application/ld+json");
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": graphNodes(page),
  });
}

/**
 * 向已安装的百度统计上报电话点击。统计脚本不存在时直接返回。
 * @param {string} href
 */
export function trackPhoneClick(href) {
  if (!window._hmt || !window._hmt.push) {
    return;
  }
  window._hmt.push(["_trackEvent", "contact", "click", href || "tel"]);
}
